import {
    AuthSession,
    signIn as amplifySignIn,
    signOut as amplifySignOut,
    fetchAuthSession,
    getCurrentUser,
} from 'aws-amplify/auth';

import { useAuthStore } from '@/stores/authStore.ts';

export const loadUserProperties = async (): Promise<void> => {
    const session: AuthSession = await fetchAuthSession();
    const token = session?.tokens?.idToken?.payload;
    if (!token) return;

    useAuthStore.setState({
        userEmail: token.email as string,
    });
};

export const signIn = async (email: string, password: string): Promise<void> => {
    const response = await amplifySignIn({
        username: email,
        password: password,
    });

    if (response.isSignedIn) {
        const user = await getCurrentUser();
        await loadUserProperties();
        useAuthStore.setState({ user: user, isUserSet: true });
    }
};

export const signOut = async (): Promise<void> => {
    await amplifySignOut();
    useAuthStore.getState().reset();
};

export const getIdToken = async (): Promise<string | undefined> => {
    const session: AuthSession = await fetchAuthSession();

    return session.tokens?.idToken?.toString();
};

export const getAccessToken = async (): Promise<string | undefined> => {
    const session: AuthSession = await fetchAuthSession();

    return session.tokens?.accessToken?.toString();
};

export const getSession = async (): Promise<AuthSession> => {
    const session: AuthSession = await fetchAuthSession();

    return session;
};

export const copyIdToken = async (): Promise<void> => {
    const token = await getIdToken();
    if (!token) {
        // showErrorNotification('Failed to copy!');
        return;
    }
    await navigator.clipboard.writeText(token);
    // showSuccessNotification('Copied to clipboard!');
};
